import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import logo from '../images/logo svg.svg'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScienceOpen, setIsScienceOpen] = useState(false);
  const [isNewsOpen, setIsNewsOpen] = useState(false);
  const location = useLocation(); // Get the current location

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Toggle for Science dropdown in mobile view
  const toggleScience = () => {
    setIsScienceOpen(!isScienceOpen);
  };

  // Toggle for News & Updates dropdown in mobile view
  const toggleNews = () => {
    setIsNewsOpen(!isNewsOpen);
  };

  // Function to determine if the link is active
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-black px-8 lg:px-24 xl:px-24 pt-6">
      <div className="container mx-auto flex justify-between text-white items-center py-6">
        <div className="flex items-center space-x-4">
          {/* Fixed: Use Link instead of anchor tag */}
          <Link to="/" style={{ cursor: 'pointer' }}>
            <img src={logo} height={60} width={60} alt="Centella Logo" />
          </Link>
          <div className="text-xl font-medium flex font-jost items-center space-x-0.5">
            <span>
              CENTELLA AI <br />
              THERAPEUTICS
            </span>
          </div>
        </div>

        <div className="hidden md:flex space-x-8 text-lg items-center">
          {/* Fixed: Added explicit cursor-pointer class with !important */}
          <Link
            to="/"
            className={`hover:text-purple-500 cursor-pointer ${isActive('/') ? 'border-b-2 border-purple-500' : ''}`}
            style={{ cursor: 'pointer !important' }}
          >
            Platform
          </Link>
          <Link
            to="/pipeline"
            className={`hover:text-purple-500 cursor-pointer ${isActive('/pipeline') ? 'border-b-2 border-purple-500' : ''}`}
            style={{ cursor: 'pointer !important' }}
          >
            Pipeline
          </Link>
          <div className="relative group">
            <button className="hover:text-purple-500 focus:outline-none cursor-pointer">
              Science
            </button>
            <div className="absolute right-0 mt-2 w-48 bg-black text-white border border-gray-200 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 group-hover:block rounded-md">
              <Link
                to="/publications"
                className="block px-4 py-2 hover:bg-gray-700 cursor-pointer"
              >
                Publications
              </Link>
              <Link
                to="/case-study"
                className="block px-4 py-2 hover:bg-gray-700 cursor-pointer"
              >
                Case Study
              </Link>
            </div>
          </div>

          <div className="relative group">
            <button className="hover:text-purple-500 focus:outline-none cursor-pointer">
              Insights & Updates  
            </button>
            <div className="absolute right-0 border border-white mt-2 w-48 bg-black text-white shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 group-hover:block rounded-md">
              {/* <Link
                to="/news-list"
                className="block px-4 py-2 hover:bg-gray-700 cursor-pointer"
              >
                Media Coverage
              </Link> */}
                            <Link
                to="/insights"
                className="block px-4 py-2 hover:bg-gray-700 cursor-pointer"
              >
                Insights
              </Link>
              <Link
                to="/blogs"
                className="block px-4 py-2 hover:bg-gray-700 cursor-pointer"
              >
                Blogs
              </Link>

            </div>
          </div>

          <Link
            to="/teams"
            className={`hover:text-purple-500 cursor-pointer ${isActive('/teams') ? 'border-b-2 border-purple-500' : ''}`}
            style={{ cursor: 'pointer !important' }}
          >
            About Us
          </Link>
          <Link
            to="/contact"
            className="text-white font-semibold py-2 px-4 rounded-[50px] border-2 border-[#6FC5F0] hover:border-blue-500 transition duration-300 cursor-pointer"
          >
            Contact Us
          </Link>
        </div>
        
        <div className="md:hidden">
          <button onClick={toggleMenu} className="cursor-pointer">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
              ></path>
            </svg>
          </button>
        </div>
      </div>
      
      {isOpen && (
        <div className="md:hidden">
          <div className="flex flex-col space-y-4 mt-4 px-8">
            <Link
              to="/"
              className={`hover:text-purple-500 text-white cursor-pointer ${isActive('/') ? 'border-b-2 border-purple-500' : ''}`}
            >
              Platform
            </Link>
            <Link
              to="/pipeline"
              className={`hover:text-purple-500 text-white cursor-pointer ${isActive('/pipeline') ? 'border-b-2 border-purple-500' : ''}`}
            >
              Pipeline
            </Link>
            <div className="relative">
              <button onClick={toggleScience} className="hover:text-purple-500 focus:outline-none text-white cursor-pointer">
                Science
              </button>
              {isScienceOpen && (
                <div className="mt-2 pl-4">
                  <Link
                    to="/publications"
                    className="block py-2 hover:text-purple-500 text-white cursor-pointer"
                  >
                    Publications
                  </Link>
                  {/* <Link
                    to="/case-study"
                    className="block py-2 hover:text-purple-500 text-white cursor-pointer"
                  >
                    Case Study
                  </Link> */}
                </div>
              )}
            </div>
            <div className="relative">
              <button onClick={toggleNews} className="hover:text-purple-500 focus:outline-none text-white cursor-pointer">
                News & Updates
              </button>
              {isNewsOpen && (
                <div className="mt-2 pl-4">
                  <Link
                    to="/news-list"
                    className="block py-2 hover:text-purple-500 text-white cursor-pointer"
                  >
                    Media Coverage
                  </Link>
                  <Link
                    to="/blogs"
                    className="block py-2 hover:text-purple-500 text-white cursor-pointer"
                  >
                    Blogs
                  </Link>
                  <Link
                    to="/press-release"
                    className="block py-2 hover:text-purple-500 text-white cursor-pointer"
                  >
                    Press Release
                  </Link>
                </div>
              )}
            </div>
            <Link
              to="/teams"
              className={`hover:text-purple-500 text-white cursor-pointer ${isActive('/teams') ? 'border-b-2 border-purple-500' : ''}`}
            >
              About Us
            </Link>
            <Link
              to="/contact"
              className={`hover:text-purple-500 text-white cursor-pointer ${isActive('/contact') ? 'border-b-2 border-purple-500' : ''}`}
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;